import React, { Component, Suspense } from "react";
import { Router, Switch, Route } from "react-router-dom";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import { history } from "../store/_helpers";
import { alertActions } from "../store/_actions";
import "../../node_modules/font-awesome/scss/font-awesome.scss";
import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../publicRoutes";

let ga_user_id = "";
let user = JSON.parse(localStorage.getItem("user")) || null;
if (user === null) {
      ga_user_id = "Anonymous_Threat";
    } 
else {
      ga_user_id = user.ga_user_id || "demo";
    }

ReactGA.initialize("UA-198834203-1");

const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"),
  loading: Loader,
});

class App extends Component {
  constructor(props) {
    super(props);
    history.listen((location, action) => {
      ReactGA.set({userId: ga_user_id});
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname + window.location.search);
      this.props.clearAlerts();
    });
  }
  render() {
    const menu = routes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={(props) => <route.component {...props} />}
        />
      ) : null;
    });

    return (
      <Aux>
        <ScrollToTop>
          <Suspense fallback={<Loader />}>
            <Router history={history}>
              <Switch>
                {menu}
                <Route path="/" component={AdminLayout} />
              </Switch>
            </Router>
          </Suspense>
        </ScrollToTop>
      </Aux>
    );
  }
}

const actionCreators = {
  clearAlerts: alertActions.clear,
};

export default connect(null, actionCreators)(App);
